module.exports = __webpack_public_path__ + "media/theme/icon__payment__paypal-3d446d47.svg";